import React from "react";
import "./abouttemple.css";
import templeJson from "../../../../config/temple.json";
import { Container, Grid, } from "@mui/material";

function AboutTemple(props) {
  const { templeMission } = props;

  return (
    <>
      <Grid className="py-4 about-temple-bg">
          <Container>
            <Grid container py={4}>
                <Grid item lg={12} md={12} sm={12} xs={12} className="text-center">
                    <h6  className="section-title text-center text-primary text-uppercase title-tl mb-2">
                      {templeJson["templeName"]}
                    </h6>
                    <h1 className="mb-4">
                      <span className="text-secundary">Temple Mission</span>
                    </h1>
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} px={2}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: templeMission?.data?.description,
                        }}
                      />
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} px={1} className="text-center">
                      <img
                        src={templeMission?.data?.image}
                        alt="spotlight"
                        className="img-fluid"
                      />
                </Grid>
            </Grid>
          </Container>
      </Grid>
    </>
  );
}
export default AboutTemple;
